import { z } from "zod";

/** A line as the panel and the email see it — priced by the server, never by the model. */
export const orderLineDtoSchema = z.object({
  productId: z.string(),
  title: z.string(),
  quantity: z.number().int().positive(),
  priceCents: z.number().int().nonnegative(),
});
export type OrderLineDto = z.infer<typeof orderLineDtoSchema>;

export const orderStatusSchema = z.enum(["draft", "confirmed", "submitted", "failed"]);
export type OrderStatusDto = z.infer<typeof orderStatusSchema>;

export const orderDtoSchema = z.object({
  id: z.string().uuid(),
  conversationId: z.string().uuid(),
  status: orderStatusSchema,
  items: z.array(orderLineDtoSchema),
  customer: z.record(z.unknown()).nullable(),
  totalCents: z.number().int(),
  currency: z.string(),
  /** How it left the building — `order_email` in v1. Absent while still a draft. */
  sinkKind: z.string().nullable(),
  sinkRef: z.string().nullable(),
  error: z.string().nullable(),
  createdAt: z.string(),
  confirmedAt: z.string().nullable(),
  submittedAt: z.string().nullable(),
});
export type OrderDto = z.infer<typeof orderDtoSchema>;

export const feedbackDtoSchema = z.object({
  id: z.string().uuid(),
  conversationId: z.string().uuid(),
  messageId: z.string().uuid().nullable(),
  rating: z.number().int(),
  comment: z.string().nullable(),
  createdAt: z.string(),
});
export type FeedbackDto = z.infer<typeof feedbackDtoSchema>;
